export default {
    methods: {
        filterSelects(list) {
            return _.filter(this.lists[list], ['id_list_estado', 1])
        },
        async getFiltrar() {
            let dataRoute = {}
            let others = []
            let filterKeys = Object.keys(this.filter);
            for (let i = 0; i < filterKeys.length; i++) {
                if (filterKeys[i] !== 'mes_periodo' && filterKeys[i] !== 'ano_periodo') {
                    if (this.filter[filterKeys[i]] !== null && this.filter[filterKeys[i]].id !== undefined) {
                        others.push([filterKeys[i], this.filter[filterKeys[i]].id])
                    } else if (this.filter[filterKeys[i]].length > 0) {
                        others.push([filterKeys[i], 'like', '%' + this.filter[filterKeys[i]].join('%') + '%'])
                    }
                } else {
                    dataRoute[filterKeys[i]] = this.filter[filterKeys[i]].id
                }

            }
            dataRoute.others = others
            await this.getDataGet({ route: 'get_archivoretiros', data: dataRoute })
                //frontend await this.searchGetIdb({tabla:'afiliacion_registro', campo:'id_datos_asesor', value: this.filter.servicios.id})
        },
        async getLimpiar() {
            this.filter = {
                mes_periodo: this.gettersDatalist('list_mes', this.fecha().fecha.mesHoy)[0],
                ano_periodo: this.gettersDatalist('list_ano', this.fecha().fecha.anoHoy)[0],
                id_datos_razon: this.gettersDatalist('datos_razon', 1)[0],
                servicios: [],
            }

            await this.resetDataGet()
        }
    },
}